import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThemeService } from '../../../core/services/theme.service';
import { LucideIconsModule } from '../../lucide-icons.module';

@Component({
    selector: 'app-theme-switcher',
    standalone: true,
    imports: [CommonModule, LucideIconsModule],
    templateUrl: './theme-switcher.component.html',
    styleUrls: ['./theme-switcher.component.scss']
})
export class ThemeSwitcherComponent {
    readonly themeService = inject(ThemeService);

    isLight(): boolean {
        return this.themeService.theme() === 'white';
    }

    toggleTheme(): void {
        this.themeService.setTheme(this.isLight() ? 'green' : 'white');
    }
}
